import styled from 'styled-components';

import InfoIconOutline from 'svg/InfoIconOutline';

type TimingExplainerProps = {
  jobType: 'summary' | 'comparison';
};

const TimingExplainer = ({ jobType }: TimingExplainerProps) => {
  return (
    <OuterContainer>
      <Container>
        <InfoIconOutline />
        <div>
          <span>Generating your {jobType} may take a few minutes.</span> The {jobType} will continue to generate in the
          background if you navigate away.
        </div>
      </Container>
    </OuterContainer>
  );
};

export default TimingExplainer;

const OuterContainer = styled.div`
  position: absolute;
  bottom: 40px;
  width: 100%;
`;

const Container = styled.div`
  position: relative;
  margin: 40px 40px 0 40px;
  display: flex;
  align-items: center;
  border: 1px solid rgba(89, 62, 228, 0.1);
  border-radius: 8px;
  padding: 20px;
  font-size: 12px;
  background: linear-gradient(270deg, rgb(246, 241, 252) 0%, rgb(244, 239, 252) 48.58%, rgb(242, 238, 252) 100%);

  span {
    font-weight: bold;
  }

  svg {
    margin-right: 16px;
  }
`;
